<template>
    <div class="page">
        <div class="header">
            <Header :current="['zt']"></Header>
            <div class="zt-title">商河县主体名录库</div>
            <div class="header-search">
                <a-input-search
                    placeholder="输入搜索内容"
                />
            </div>
        </div>
        <div class="content">
            <div class="zt-tab">
                <div :class="{'zt-tab-selected': isSelected === 1 }" @click="tabClick(1)">合作社</div>
                <div :class="{'zt-tab-selected': isSelected === 2 }" @click="tabClick(2)">家庭农场</div>
                <div :class="{'zt-tab-selected': isSelected === 3 }" @click="tabClick(3)">服务组织</div>
            </div>
            <div class="zt-table">
                <a-table :dataSource="dataList" :columns="columns">
                    <template #status="{ text }">
                        <a v-if="text == '已认证'">{{ text }}</a>
                        <p v-else style="color:#ff6868;">{{ text }}</p>
                    </template>
                    <template #action="{ record }">
                        <a @click="handleTableClick(record.key)">查看</a>
                    </template>
                </a-table>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import {ref} from 'vue'
import {getList} from "@/api/directories"
import router from "@/router"
import {useRoute} from "vue-router"
const columns = [
    {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        align: 'center'
    },
    {
        title: '主体名称',
        dataIndex: 'name',
        key: 'name',
        align: 'center'
    },
    {
        title: '服务类型',
        dataIndex: 'type',
        key: 'type',
        align: 'center'
    },
    {
        title: '联系地址',
        dataIndex: 'address',
        key: 'address',
        align: 'center'
    },
    {
        title: '联系人',
        dataIndex: 'person',
        key: 'person',
        align: 'center'
    },
    {
        title: '联系电话',
        dataIndex: 'phone',
        key: 'phone',
        align: 'center'
    },
    {
        title: '认证状态',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        slots: {
            customRender: 'status',
        }
    },
    {
        title: '操作',
        key: 'operation',
        fixed: 'right',
        width: 100,
        slots: {
            customRender: 'action',
        },
    },
]
export default {
    name: "MingLuTable",
    setup() {
        const isSelected = ref(1)
        const dataList = ref()
        const townId = ref('')
        const route = useRoute()
        return {
            isSelected,
            columns,
            dataList,
            route,
            townId
        }
    },
    mounted() {
        this.townId = this.route.query.townId
        this.initList()
    },
    methods: {
        tabClick(val) {
            this.isSelected = val
            this.initList()
        },
        async initList() {
            const params = {
                "current": 1,
                "model": {
                    subjectType: this.isSelected,
                    town: this.townId
                },
                "size": 1000,
            }
            const data = await getList(params)
            this.dataList = data.records.map((k, index) => ({
                key: k.id,
                index: index + 1,
                name: k.subjectName,
                type: k.subjectType.desc,
                address: k.address,
                person: k.legalPerson,
                phone: k.contactsPhone,
                status: k.authentication.desc
            }))
        },
        handleTableClick(key) {
            router.push({ name: '/portal/MingLuDetails', query: {key: key}})
        }
    },
    components: {
        Header,
        Footer
    }
}
</script>

<style scoped lang="stylus">
    a {
        color #1890FF
    }
    .page {
        width 100%
        height 100%
        position relative
        font-size 16px
        background-color #FFF
        .header {
            width 100%
            height 730px
            padding-top 130px
            box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
            border-bottom-left-radius 315px
            border-bottom-right-radius 315px
            background-image url("../../assets/img/portal_service_bg.png")
            background-size 100% 100%
            background-repeat no-repeat
            .zt-title {
                margin-top 200px
                width 100%
                font-size 48px
                color #FFF
                font-weight bold
                text-align center
            }
            .header-search {
                width 600px
                height 70px
                margin 60px auto 200px auto
            }
            .header-search >>> .ant-input-affix-wrapper {
                height 70px
                font-size 22px
            }
            .header-search >>> .ant-input-affix-wrapper > input.ant-input {
                border-radius 5.333vw
                font-size 18px
                padding 4px 20px
            }
            .header-search >>> .ant-input-affix-wrapper .ant-input-suffix {
                margin-right 10px
            }
        }
        .content {
            width 100%
            min-height 200px
            .zt-tab {
                width 100%
                height 110px
                line-height 110px
                margin 50px 0
                display flex
                flex-wrap nowrap
                justify-content center
                .zt-tab-selected {
                    border-bottom 3px solid #167ADA
                    color #167ADA
                }
            }
            .zt-tab div {
                width 260px
                text-align center
                font-size 42px
                margin 0 90px
                cursor pointer
                transition .3s
            }
            .zt-tab div:hover {
                color #167ADA
            }
            .zt-table {
                width 100%
                padding 0 80px
            }
            .zt-table >>> .ant-table table {
                font-size 24px
            }
            .zt-table >>> .ant-table-thead > tr > th {
                font-size 30px
                color #222
            }
            .zt-table >>> .ant-pagination-item {
                font-size 22px
                height 80px
                width 80px
                line-height 80px
            }
            .zt-table >>> .ant-pagination-prev, .ant-pagination-next {
                height 80px
                width 80px
                line-height 80px
            }
            .zt-table >>> .ant-pagination-next {
                height 80px
                width 80px
                line-height 80px
            }
            .zt-table >>> .anticon {
                font-size 22px
            }
            .zt-table >>> .ant-table-tbody > tr > td {
                padding 36px 16px
            }
        }
    }
</style>